import { PropsWithChildren } from "react";

import { MessagingProvider } from "@/components/Messaging";
import { WSTokenProvider } from "@/components/Messaging/WSTokenProvider";

const UserChannelProvider = ({ children }: PropsWithChildren) => (
  <WSTokenProvider>
    <MessagingProvider>{children}</MessagingProvider>
  </WSTokenProvider>
);

export default UserChannelProvider;
